import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { orgsApi } from '@/api/index';

export const fetchOrgs = createAsyncThunk(
  'orgs',
  async (_, thunkAPI) => {
    try {
      const response = await orgsApi.getAllV2();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
